import { NominationJudgedSummary } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationJudgedSummaries: (
  fetchContext: FetchContext,
  userId: number,
  accessToken?: string,
) => Promise<NominationJudgedSummary[]> = (fetchContext, userId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/judges/${userId}/nomination-summaries`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationJudgedSummary[]>(fetchContext.errorStore, response, 'get nomination judged summaries'));
